<template>
  <div
    class="custom-scroll to-do__item__list"
    aria-hidden="true"
  >
    <div
      v-for="index in 3"
      :key="index"
      class="to-do__item__wrapper to-do__item-skeleton"
    >
      <Skeletor class="to-do__item-skeleton-checkbox" />
      <div class="to-do__item-skeleton-content">
        <Skeletor class="to-do__item-skeleton-title" />
        <Skeletor class="to-do__item-skeleton-label" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeletor } from "vue-skeletor"
</script>
